module.exports = __webpack_public_path__ + "static/img/manualOffline.302c66a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/manualOffline.png
// module id = Rutu
// module chunks = 11